import projectListMapComponent from './project-list-map.component';

const projectListMapModule = angular.module('projectListMap', [
])
  .component('projectListMap', projectListMapComponent)
  .name;

export default projectListMapModule;
